export function getSubdomain(url: string): string | null {
  try {
    const urlObj = new URL(url); // Parse the URL
    const { hostname } = urlObj;

    // Check for IP addresses (192.x.x.x or 127.x.x.x)
    if (hostname.startsWith('192.') || hostname.startsWith('127.')) {
      return null;
    }

    // Split the hostname into parts
    const parts: string[] = hostname.split('.');

    // Get the top-level domain (TLD)
    const tld: string = parts.slice(-1)[0];
    const ignoredTLDs: Set<string> = new Set(['dev', 'app', 'run']);

    // If the TLD is in the ignored list, return null
    if (ignoredTLDs.has(tld)) {
      return null;
    }

    // Check if there's a subdomain (more than two parts, accounting for TLD and domain)
    if (parts.length > 2) {
      const subdomain: string = parts.slice(0, parts.length - 2).join('.');

      // Ignore specific subdomain cases
      const ignoredSubdomains: Set<string> = new Set([
        'www',
        'dev',
        'app',
        'run',
        'localhost',
      ]);

      if (ignoredSubdomains.has(subdomain)) {
        return null;
      }

      return subdomain;
    }
  } catch (error) {
    console.error('Invalid URL:', error);
  }

  return null;
}

export const removeRestAfterValue = <T>(arr: T[], value?: T): T[] => {
  if (value === undefined) {
    return []; // Remove everything if no value is provided
  }

  const index = arr.indexOf(value);
  // If the value is found, slice the array up to (and including) the value
  return index !== -1 ? arr.slice(0, index + 1) : arr;
};
